module.exports = __webpack_public_path__ + "img/banner4.06d8111b.png";